import { render, staticRenderFns } from "./CommonRuleEdit.vue?vue&type=template&id=2f3cd368&"
import script from "./CommonRuleEdit.vue?vue&type=script&lang=js&"
export * from "./CommonRuleEdit.vue?vue&type=script&lang=js&"
import style0 from "./CommonRuleEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports